import Firebase from '../../../lib/Firebase';
import Firestore from '../../../lib/Firestore';

export default {
  allProducts() {
    return Firebase.firestore()
      .collection('products')
      .get()
      .then(docs => {
        return Firestore.getCollectionData(docs);
      });
  },

  all(city) {
    return Firebase.firestore()
      .collection('cities')
      .doc(city.docId)
      .collection('products')
      .get()
      .then(docs => {
        return Firestore.getAllReferenceData(docs, ['product']);
      });
  },

  addProducts(city, products) {
    let promises = [];
    products.forEach(product => {
      const productObj = {
        product: Firebase.firestore()
          .collection('products')
          .doc(product.docId),
        category: product.category,
        active: true,
        quantities: []
      };

      promises.push(
        Firebase.firestore()
          .collection('cities')
          .doc(city.docId)
          .collection('products')
          .add(productObj)
      );
    });

    return Promise.all(promises);
  },

  deleteProduct(city, product) {
    return Firebase.firestore()
      .collection('cities')
      .doc(city.docId)
      .collection('product')
      .doc(product.docId)
      .delete();
  }
};



// WEBPACK FOOTER //
// ./src/pages/hotel/Products/service.js